const eventFilter = document.querySelector(".events-module-display .js-article-filter");

if (eventFilter) {
	const filters = eventFilter.querySelectorAll(".js-filter-button");
	const articles = eventFilter.querySelectorAll(".article");

	if (articles.length > 0 && filters.length > 0) {
		filters.forEach((filter) => {
			filter.addEventListener("click", (e) => {
				const activeEl = e.target as HTMLElement;
				const activeID = activeEl.dataset.id;

				if (activeEl.parentElement.classList.contains("active")) {
					return;
				}

				filters.forEach((filter) => {
					if (filter == activeEl) {
						filter.parentElement.classList.add("active");
					} else {
						filter.parentElement.classList.remove("active");
					}
				});

				articles[0].parentElement.classList.toggle("hidden");

				if (activeID == "all") {
					articles.forEach((el) => {
						const article = el as HTMLElement;
						article.classList.add("visible");
					});
				} else {
					articles.forEach((el) => {
						const article = el as HTMLElement;
						if (!article.dataset.id.includes(activeID)) {
							article.classList.remove("visible");
						} else {
							article.classList.add("visible");
						}
					});
				}
				setTimeout(() => {
					articles[0].parentElement.classList.toggle("hidden");
				}, 200);
			});
		});
	}
}
